import { Avatar, Link, Typography } from "@mui/material";
import React from "react";

import "./Footer.css";
import { FooterProps } from "./Footer.Props";

const Footer: React.FC<FooterProps> = ({ logoUrl, isForLayout = false }) => {
	return (
		<footer className={`${isForLayout ? "footer" : "login-footer"}`}>
			<Link
				underline="none"
				href=""
				onClick={(e) => {
					e.preventDefault();
				}}
			>
				<Avatar
					variant="square"
					src={logoUrl}
					alt="Sethewo Business Engineers"
				/>
			</Link>
			<Typography variant="body1">
				{`© Copyright 2022. All Rights Reserved | `}
				<Link
					underline="hover"
					href=""
					onClick={(e) => e.preventDefault()}
					title="Terms of Use"
				>
					Terms of Use
				</Link>
			</Typography>
		</footer>
	);
};

export default Footer;
